import React, { Component } from 'react';

class GradientSVG extends Component {
  render() {
    let { rotation } = this.props;

    let startColor='#FE9400', endColor='#FF5E3A';
    let gradientTransform = `rotate(${rotation})`;

    return (
      <svg style={{ height: 0 }}>
        <defs>
          <linearGradient id='GradientSvg' gradientTransform={gradientTransform}>
            <stop offset="0%" stopColor={startColor} />
            <stop offset="100%" stopColor={endColor} />
          </linearGradient>
        </defs>
      </svg>
    );
  }
}

export default GradientSVG;